module.exports = __webpack_public_path__ + "media/images/icons/onboarding-a829ed92ee93d6d82b4e2a4fc6559c12.svg";